export default __webpack_public_path__ + "static/media/roadhog-hogwild.59c2de16.mp3";